import { Heading } from '@backend/lib-design-system';
import { styled } from 'styled-components';

import { getMediaQuery } from '~/utils/responsive/media';

export const DescriptionWrapper = styled.div`
  width: 100%;
`;

export const DescriptionHeading = styled(Heading)`
  color: ${({ theme }) => theme.colors?.info?.normal};
  font-size: 20px;
`;

export const DescriptionItem = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 24px;
  margin-bottom: ${({ theme }) => theme.space.layout.x.l};

  ${getMediaQuery('tablet', 'laptop', 'desktop')} {
    margin-bottom: ${({ theme }) => theme.space.layout.y.m};
  }
`;

export const DescriptionText = styled.div`
  font-family: 'Red Hat Display', sans-serif;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: 0.16px;
  color: ${({ theme }) => theme.colors.body.text};

  ${getMediaQuery('tablet', 'laptop', 'desktop')} {
    font-size: 13px;
  }
`;
